export default __webpack_public_path__ + "media/zurb/img/about/talent/talent-img2-b875fd16aad77fb1d56d9404056cafa0.png";